export default "1.143.0\n"